  <div class="sliding-button -container" *ngIf="options && options.length > 0">
    <ul #slidingOptions>
      <li *ngFor="let option of options">
        <a>{{ option }}</a>
      </li>
      <div class="sliding-button -slider" #slider></div>
    </ul>
  </div>